<template>
  <div>
    Sign request
    <div ref="container">
    </div>
  </div>
</template>
<script>
import HelloSign from 'hellosign-embedded';

const helloSign = new HelloSign();
const signUrl = 'https://app.hellosign.com/editor/embeddedSign?signature_id=65a643f1600884a81c73f875161bbbfb&token=40b8c07c55129ba7650b3a671aea1576';

export default {
  mounted() {
    console.log(this.$refs);
    helloSign.open(signUrl, {
      clientId: 'ce182b7c486429e889c70230a9bd6df5',
      skipDomainVerification: true,
      debug: true,
      container: this.$refs.container,
    });
  }
};
</script>
